/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_1_3 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [-53.401081141565385, 26.017241632351077],
                        [-76.38447957906538, 26.017241632351077],
                        [-76.38447957906538, 8.42884252649187],
                        [-53.401081141565385, 8.42884252649187],
                        [-53.401081141565385, 26.017241632351077]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_1_3
